import Home from '../sections/Home';
import Experience from '../sections/Experience';
import About from '../sections/About';
import Projects from '../sections/Projects';
import Contact from '../sections/Contact';

const Main = () => {
    return (
        <>
            <Home />
            <Experience />
            <About />
            <Projects />
            <Contact />
        </>
    )
}

export default Main;